import styled from '@emotion/styled';
import * as React from 'react';

const Root = styled('div')(() => ({
  border: '1px solid',
  borderRadius: '4px',
  width: '100%',
  // height: '300px',
  marginBottom: '1rem',
}));

export type Props = React.PropsWithChildren & React.ComponentProps<typeof Root>;

const Area = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, ...rest } = props;
  return (
    <Root ref={ref} {...rest}>
      {children}
    </Root>
  );
});

export default React.memo(Area);
